/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetFilesErrorResponse, GetFilesResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncountersFiles = (encounterId: number, signal?: AbortSignal) => {
  return api<GetFilesResponse>({
    url: `/api/encounters/${encounterId}/files`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersFilesQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/files`] as const;
};

export const getGetEncountersFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersFiles>>,
  TError = GetFilesErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncountersFiles>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersFilesQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersFiles>>> = ({ signal }) =>
    getEncountersFiles(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersFiles>>
>;
export type GetEncountersFilesQueryError = GetFilesErrorResponse;

export function useGetEncountersFiles<
  TData = Awaited<ReturnType<typeof getEncountersFiles>>,
  TError = GetFilesErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncountersFiles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersFiles>>,
          TError,
          Awaited<ReturnType<typeof getEncountersFiles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersFiles<
  TData = Awaited<ReturnType<typeof getEncountersFiles>>,
  TError = GetFilesErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersFiles>>,
          TError,
          Awaited<ReturnType<typeof getEncountersFiles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersFiles<
  TData = Awaited<ReturnType<typeof getEncountersFiles>>,
  TError = GetFilesErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncountersFiles>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersFiles<
  TData = Awaited<ReturnType<typeof getEncountersFiles>>,
  TError = GetFilesErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncountersFiles>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersFilesQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
